'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { HeaderLinkScrollingMenuDSWidget } from './header-link-scrolling-menu-ds-widget'
import { HeaderLinkScrollingMenuWidgetLegacy } from './header-link-scrolling-menu-widget-legacy'

import type { HeaderLinkScrollingMenuWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

// Router: DS branch (the DS header's NavCategoryRow band) when the Design System gate is active,
// else the legacy widget (the legacy header's tertiary-menu row design).
const HeaderLinkScrollingMenuWidgetComponent = (props: PLTypedWidgetProps<HeaderLinkScrollingMenuWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <HeaderLinkScrollingMenuDSWidget {...props} />
  }
  return <HeaderLinkScrollingMenuWidgetLegacy {...props} />
}

/**
 * HEADER_LINK_SCROLLING_MENU — the mWeb quick-link scrolling menu that replaces the header's
 * tertiary-menu row on PL pages. `isEmpty` collapses the widget shell when the BE disables it or
 * sends no links ("empty ⇒ render nothing" per the proto contract), instead of leaving an empty
 * placeholder at the top of the page.
 */
export const HeaderLinkScrollingMenuWidget: PLTypedWidgetInterface<
  HeaderLinkScrollingMenuWidgetData,
  WidgetType.HEADER_LINK_SCROLLING_MENU
> = {
  id: WidgetType.HEADER_LINK_SCROLLING_MENU,
  errorBoundary: PLBaseErrorBoundary,
  render: HeaderLinkScrollingMenuWidgetComponent,
  isEmpty: (props: PLTypedWidgetProps<HeaderLinkScrollingMenuWidgetData>) => {
    const data = props.data.headerLinkScrollingMenuData
    // proto3 JSON omits empty repeated fields, so `items` can be absent at runtime even though the
    // generated type declares it required (same guard class as pl-handler-shared's `experiments`).
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return !data?.enabled || (data.items ?? []).length === 0
  },
}
